import CallService from 'services/CallService';
import { jsonResponseHandler } from './utils';

export const MarketsService = {
  getAllMarkets: function () {
    return CallService.authorizedCall('GET', '/markets').then(jsonResponseHandler);
  },
  patchMarket: function (data, id) {
    return CallService.authorizedCall('PATCH', `/markets/${id}`, data).then(jsonResponseHandler);
  },
  postMarket: function (data) {
    return CallService.authorizedCall('POST', '/markets', data).then(jsonResponseHandler);
  }
};

export default MarketsService;
